import React, {Component} from 'react';
import {CSSTransition} from 'react-transition-group'
import Cookies from 'js-cookie';

// Components
import {Link} from 'react-router-dom';
import {Container, Row, Col, Button} from 'reactstrap';
import FullPageLayout from '../../components/FullPageLayout';
import CenterPage from '../../components/CenterPage';
import { ResponsiveImage } from 'dabbl-react-components';

// Data
import tutorialData from '../data/waysToSave';

class TutorialPage extends Component {

    state = {
        currIdx: 0
    }

  componentWillMount() {
    //   if (Cookies.get("adjoy_seenTutorial")) {
    //     window.localStorage.setItem("adjoy_seenTutorial", "true");
    //   }
    // if (window.localStorage.getItem("adjoy_seenTutorial")) {
    //   this.props.history.push('/app/campaigns')
    // }
  }

    componentDidMount() {
        this.props.setLoading(false);
    }

    nextStep() {
        const {currIdx} = this.state;
        this.setState({currIdx: currIdx + 1});
    }

    handleGetStarted() {
        // window.localStorage.setItem("adjoy_seenTutorial", "true");
        this.props.setLoading(true);
    }

    render() {
        const {currIdx} = this.state;
        const btnText = (tutorialData[currIdx + 1])
            ? 'Next'
            : 'Get Started';

        return (
            <div className="TutorialPage">
                <FullPageLayout>
                    <CenterPage xs>
                        <Container>
                            <Row>
                                {tutorialData.map((data, i) => {
                                    return (currIdx === i && (
                                        <CSSTransition
                                            key={i}
                                            in={true}
                                            appear={true}
                                            enter={true}
                                            exit={false}
                                            timeout={{enter: 250, exit: 250}}
                                            classNames="Transition_fadeIn">
                                            <Col
                                                xs={12}
                                                sm={{size: 8, offset: 2}}
                                                md={{size: 6, offset: 3}}
                                                lg={{size: 4, offset: 4}}
                                                // xl={{size: 8, offset: 2}}
                                                className="text-center"
                                                style={{marginTop: '2rem', marginBottom: '2rem'}}>
                                                <ResponsiveImage
                                                    src={data.imgUrl}
                                                    alt={data.text}
                                                    aspectRatio="1:1"/>

                                                <div className="TutorialPage_card_title">
                                                    {data.title}
                                                </div>

                                                <div className="TutorialPage_card_text">
                                                    {data.text}
                                                </div>

                                                {data.subtext && (
                                                    <div className="TutorialPage_card_text">
                                                        {data.subtext}
                                                    </div>
                                                )}

                                                {/* Button */}
                                                {btnText === 'Next' && (
                                                    <Button
                                                        onClick={() => this.nextStep()}
                                                        className="TutorialPage_button"
                                                        type="button">
                                                        {btnText}
                                                    </Button>
                                                )}

                                                {btnText === 'Get Started' && (
                                                    <Link
                                                        to="/app/campaigns"
                                                        onClick={() => this.handleGetStarted()}>
                                                        <Button
                                                            className="TutorialPage_button"
                                                            type="button">
                                                            {btnText}
                                                        </Button>
                                                    </Link>
                                                )}
                                            </Col>
                                        </CSSTransition>
                                    ));
                                })}
                            </Row>
                        </Container>
                    </CenterPage>
                </FullPageLayout>
            </div>
        );
    }
}

export default TutorialPage;



// WEBPACK FOOTER //
// ./src/pages/Tutorial/Tutorial.js